import { TagRow } from "@components/V2/Vault/Common/DefiTypes";
import { useMemo } from "react";
import BadgeTooltip from "@components/Tooltip/BadgeTooltip";
import BaseImage from "@components/BaseImage";
import { getImgSrcFromStorage } from "@components/StorageImage";

// Use Tailwind theme equivalents
// bg.primary => #f4f4f7, text.primary => #1a1a1a
const BADGE_BG_COLOR = "#f4f4f7";
const BADGE_TEXT_COLOR = "#1a1a1a";

interface Props {
  allTags: TagRow[];
  tags: string;
  tagWithImage?: string;
  tagImagePath?: string;
  featuredDefi?: boolean;
}

const DeFiTag = ({
  tag,
  className = "",
}: {
  tag: string;
  className?: string;
}) => {
  return (
    <div
      className={`bg-bg-primary text-text-primary rounded px-2 py-2 text-[10px] font-normal leading-[1] flex-1 ${className}`}
    >
      {tag}
    </div>
  );
};

const DefiRowTags = ({
  tags,
  tagWithImage,
  tagImagePath,
  featuredDefi = false,
}: Props) => {
  const tagItems = useMemo(() => {
    return tags
      .split(",")
      .map((tag) => tag.trim())
      .filter((tag) => tag !== "");
  }, [tags]);

  const maxTags = featuredDefi ? 2 : 1;

  return (
    <div className="flex">
      <div className="flex gap-1 flex-col">
        <div className="flex gap-1">
          {tagItems.length > 0 && tagItems[0] !== "" && (
            <div className={`${featuredDefi ? "" : "flex-1"}`}>
              <DeFiTag key={tagItems[0]} tag={tagItems[0]} />
            </div>
          )}
          {featuredDefi && tagItems.length > 1 && (
            <div className={`${featuredDefi ? "" : "flex-1"}`}>
              <DeFiTag key={tagItems[1]} tag={tagItems[1]} />
            </div>
          )}

          {tagItems.length > maxTags && (
            <BadgeTooltip
              label={`+${tagItems.length - maxTags}`}
              bgColor={BADGE_BG_COLOR}
              contentBgColor={"backgroundCard"}
              textColor={BADGE_TEXT_COLOR}
              content={
                <div className="min-w-[200px] max-w-[300px] px-5 py-2">
                  <div className="text-[16px] font-semibold px-0 mb-2">
                    Benefits
                  </div>
                  <ul className="px-4">
                    {tagItems.map((tag) => {
                      return <li key={tag}>{tag}</li>;
                    })}
                  </ul>
                </div>
              }
            />
          )}
        </div>
        {!featuredDefi && tagWithImage && tagImagePath && (
          <div className="flex items-center rounded bg-bg-primary">
            <div className="pl-1.5 flex items-center rounded-full">
              <BaseImage
                width={18}
                height={18}
                src={getImgSrcFromStorage(tagImagePath)}
                alt=""
              />
            </div>
            <DeFiTag
              key={tagItems[0]}
              tag={tagWithImage}
              className="pl-1 pr-2"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DefiRowTags;
